<template>
  <v-timeline>
    <v-timeline-item
      v-for="change in sortedTimeLine"
      :key="change.timestamp"
      :color="change.color"
      small
      right
      fill-dot
      :icon="change.icon">
      <template v-slot:opposite>
        <span>{{ change.timestamp | readableDateTimeWithDaysAgo }}</span>
      </template>
      <v-card :color="change.color" dark>
        <v-card-title>
          {{ change.title }}
        </v-card-title>
        <v-card-text class="white text--primary pt-5" v-html="change.description"/>
      </v-card>
    </v-timeline-item>
  </v-timeline>
</template>

<script>
import { capitalize } from "@/lib/string";

export default {
  name: "DealTimeline",
  props: {
    deal: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      timeline: []
    }
  },
  methods: {
    insertTimelineItem(timestamp, title, description, icon="mdi-book-variant", color="red") {
      this.timeline.push({
        timestamp: timestamp,
        title: title,
        description: description,
        icon: icon,
        color: color
      })
    }
  },
  computed: {
    sortedTimeLine() {
      let timeline = this.timeline;
      return timeline.sort((a, b) => (a.timestamp > b.timestamp ? 1 : -1));
    }
  },
  mounted() {
    let changeLog = this.deal.changeLog;
    changeLog.forEach(change => {

      let timestamp = change.changedAt;
      let title = {"CREATE": "Deal Created", "UPDATE": "Deal Updated"}[change.changeType];
      let description = "<strong>Initiated By: </strong> " + change.changedBy + "<br><hr class='mb-3'>";
      description += change.changes.join("<br>");
      let icon = {"CREATE": "mdi-star", "UPDATE": "mdi-book-variant"}[change.changeType];
      let color = {"CREATE": "red", "UPDATE": "blue"}[change.changeType]
      this.insertTimelineItem(timestamp, title, description, icon, color);
    });

    this.deal.dealcallSet.forEach(call => {
      let timestamp = call.callTime;
      let title = "Called Client: " + capitalize(call.callOutcome);
      let description = `${call.caller.firstName} ${call.caller.lastName} called client. The call type was: <strong>${call.callType.name}</strong>`;
      if (call.note && call.note !== "")
        description += `<hr class="mt-3"><p class="mt-3"><strong>Note: </strong>${call.note}</p>`
      let icon = "mdi-phone";
      let color = "blue";
      this.insertTimelineItem(timestamp, title, description, icon, color);
    });

    if (this.deal.closedAt) {
      this.insertTimelineItem(this.deal.closedAt, "Deal Closed", "Deal closed!!", "mdi-airballoon", "yellow")
    }
  }
}
</script>

<style scoped>

</style>